module.exports = __webpack_public_path__ + "static/media/Offices-1.50fbf4aa.webp";